import React from "react";
import { FormSelectField } from "@components-shared/mobile/inputs";
import { validateCountry } from "@utils";
import { CountryDataType } from "@data-types/membership/registration";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function RegistrationCountry(props: {
	countryData: CountryDataType[] | null;
	labelClassName?: string;
}) {
	const { getValues } = useFormContext();
	const { t } = useTranslation("registration");

	const { countryData, labelClassName } = props;

	return (
		<FormSelectField
			className="form__field  u-mar--bottom--reset"
			inputClassName="input input--sml input--select"
			name="countryId"
			label={t("COUNTRY_LABEL")}
			labelClassName={labelClassName}
			placeholder={t("COUNTRY_PLACEHOLDER")}
			// do not delete, maybe will be used in the future
			// popoverMsg={"COUNTRY_DESCRIPTION"}
			dropdownData={countryData}
			validate={{
				isCountryValidDependantOnDoB: (value: string) =>
					validateCountry(getValues("dob"), countryData, value),
			}}
			required
		/>
	);
}
